import router from '@/router'
import store from '@/store/'
import { getLocation } from '@/utils/route'

export const RESPONSE_EXCLUSIVE_CONTROL = 461
export const RESPONSE_UNAUTHORIZED = 463
export const RESPONSE_NOT_FOUND = [402, 404, 480, 481, 482, 483, 484, 485]
export const RESPONSE_EMAIL_EXISTS = 464
export const RESPONSE_POPUP_ERROR = 490
export const RESPONSE_SERVER_ERROR = 500

export function isNotFound(err) {
  if (typeof err.response === 'undefined') {
    return false
  }

  return RESPONSE_NOT_FOUND.includes(err.response.status)
}

export function isPopupError(err) {
  if (typeof err.response === 'undefined') {
    return false
  }

  return (
    err.response.status >= RESPONSE_POPUP_ERROR &&
    err.response.status < RESPONSE_SERVER_ERROR
  )
}

/**
 * @typedef {Object} RenderErrorOption
 * @property {Function} onErrorPopupClose
 */

/**
 * エラーに応じて画面遷移する
 * @param {Error} err エラー
 * @param {RenderErrorOption} option オプション
 */
export function renderError(err, option = {}) {
  console.error(err)

  // APIエラー以外の例外
  if (typeof err.response === 'undefined') {
    if (process.env.NODE_ENV !== 'development') {
      const location = getLocation(store, router, 'error.system')
      return router.push(location)
    }
    return false
  }

  // Not Found
  if (RESPONSE_NOT_FOUND.includes(err.response.status)) {
    return renderNotFoundError()
  }

  // 権限エラー
  if (err.response.status === RESPONSE_UNAUTHORIZED) {
    const location = getLocation(store, router, 'error.auth')
    return router.push(location)
  }

  // 排他制御エラーの場合は画面遷移せずにモーダル表示
  if (err.response.status === RESPONSE_EXCLUSIVE_CONTROL) {
    return renderExeclusiveControlError()
  }

  // エラーメッセージをモーダル表示
  if (isPopupError(err)) {
    const { message } = err.response.data
    const { onErrorPopupClose: onClose } = option
    return store.commit('popupError/OPEN', { message, onClose })
  }

  const location = getLocation(store, router, 'error.system')
  return router.push(location)
}

export function visitTokenMismatch() {
  const location = getLocation(store, router, 'error.visit-token-mismatch')
  return router.push(location)
}

/**
 * @typedef {Object} RenderNotFoundErrorOption
 * @property {boolean} replace URL履歴を残さないようする場合true
 */

/**
 * 404エラー画面に遷移する
 * @param {RenderNotFoundErrorOption} option オプション
 */
export function renderNotFoundError(option = {}) {
  const { replace: replaceFlag } = option
  const location = getLocation(store, router, 'error.not-found')
  if (replaceFlag) {
    return router.replace(location)
  }
  return router.push(location)
}

/**
 * 排他制御エラーのモーダル表示
 */
export function renderExeclusiveControlError() {
  return store.commit('app/SET_EXCLUSIVE_CONTROL', true)
}